import {
  Button,
  CollapseChevronContainer,
  CollapseChevronIcon,
  CollapseContainer,
  CollapseDropdownContainer,
  CollapseTitleContainer,
  CollapseTitleRow,
  ControlledCollapse,
  Label,
  ThemeProp,
} from '@trarc/pc-shared';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import Avatar from '../Avatar';

interface StyledCollapseProps {
  $isExpanded: boolean;
}

export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0;
  background: ${(props: ThemeProp) => props.theme.colors.white};
`;

export const VersionNumberContainer = styled.div`
  display: flex;
  align-self: center;
  transition: all ease-out 0.3s;
  gap: 0.25rem;

  font-size: ${(props: ThemeProp) => props.theme.fontSize.m};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  color: ${(props: ThemeProp) => props.theme.colors.c400};
`;

export const VersionNumberLabel = styled.div<StyledCollapseProps>`
  align-self: center;
  opacity: ${({ $isExpanded }: StyledCollapseProps) => ($isExpanded ? '1' : '0')};
  transition: all ease-out 0.3s;
`;

export const UserInfoRow = styled.div`
  display: flex;
  width: 13rem;
  padding-left: 0.25rem;
  align-items: center;
  gap: 1rem;
`;

export const StyledAvatar = styled(Avatar)`
  width: 2.6rem;
  height: 2.6rem;
`;

export const UserName = styled.div<StyledCollapseProps>`
  color: ${(props: ThemeProp) => props.theme.colors.black};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.m};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 8rem;

  opacity: ${({ $isExpanded }: StyledCollapseProps) => ($isExpanded ? '1' : '0')};
  transition: all ease-out 0.3s;

  &:hover {
    color: ${(props: ThemeProp) => props.theme.colors.primary};
  }
`;

export const StyledCollapse = styled(ControlledCollapse)<StyledCollapseProps>`
  ${CollapseTitleContainer} {
    flex-direction: row-reverse;
    justify-content: space-between;
    font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
    font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
    color: ${(props: ThemeProp) => props.theme.colors.c400};

    ${CollapseChevronIcon} {
      stroke: ${(props: ThemeProp) => props.theme.colors.c400};
      transition: all ease-out 0.15s;
      transform: ${({ $isExpanded }) => ($isExpanded ? 'rotate(90deg)' : 'rotate(0deg)')};
      align-self: center;
    }
  }

  ${CollapseContainer} {
    width: 17rem;
  }

  ${CollapseTitleRow} {
    background-color: ${(props: ThemeProp) => props.theme.colors.white};
    width: 16rem;
    border: none;
    align-items: center;
  }

  ${CollapseDropdownContainer} {
    background-color: ${(props: ThemeProp) => props.theme.colors.white};
    padding-left: 4rem;
    width: 13rem;
    border: none;
    gap: 1rem;
  }

  ${CollapseChevronContainer} {
    transform: rotate(-0.25turn);
    padding: 1rem 1rem 0rem 1rem;
  }
`;

export const StyledNavLink = styled(NavLink)`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  color: ${(props: ThemeProp) => props.theme.colors.c400};
  width: 11rem;
  border-radius: 0.5rem;
  padding: 0.4rem;

  &:hover {
    background-color: ${(props: ThemeProp) => props.theme.colors.blackLowOpacity};
  }

  &.active {
    background: ${(props: ThemeProp) => props.theme.colors.secondary}15;
    color: ${(props: ThemeProp) => props.theme.colors.primary};
  }
`;

export const StyledButton = styled(Button)`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  font-family: ${(props: ThemeProp) => props.theme.fonts.primary};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  background-color: ${(props: ThemeProp) => props.theme.colors.white};
  justify-content: left;
  height: 2rem;
  width: 11rem;
  border-radius: 0.5rem;
  padding: 0.5rem;

  ${Label} {
    color: ${(props: ThemeProp) => props.theme.colors.c400};
  }

  &:hover {
    background-color: ${(props: ThemeProp) => props.theme.colors.blackLowOpacity};
  }

  &.active {
    background: ${(props: ThemeProp) => props.theme.colors.secondary}15;
    color: ${(props: ThemeProp) => props.theme.colors.primary};
  }
`;
